<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :doneFunction="doneFunction"
               tableApi="admin/order/getOnlyTodayOrderLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_id">
          <Select v-model="searchData.station_id" :filterable="true">
            <Option v-for="(item,key) in stations" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </template>

    </pageTable>

    <userDetail ref="editModel" :user_id="editUserId" @close="editUserId=0"></userDetail>


    <orderDetail v-if="showOrderDetail"
                  :show-edit="showOrderDetail"
                  :order_id="editOrderId"
                  ref="orderDetail"
                  @cancel-edit="showOrderDetail=false"
    >
    </orderDetail>

    <doSettle v-if="showSettleDetail"
              :show-edit="showSettleDetail"
              :order_id="settleOrderId"
              ref="settleDetail"
              @cancel-edit="closeSettleDetail"
              @settle-success="settleSuccess"
    >
    </doSettle>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import userDetail from "../user/detail";
  import orderDetail from "./detail";
  import XLSX from 'xlsx'

  export default {
    name: "lists",
    components:{pageTable,userDetail,orderDetail},
    data() {
      return {
        editUserId:0,     //编辑的ID
        editOrderId:0,     //编辑的ID
        showOrderDetail:false,
        showSettleDetail:false,
        settleOrderId:0,
        settleRecord:{
          isShow:false,
          order_id:0,
        },
        searchData: {
          mobile: '',
          nick_name:'',
          car_number:'',
          create_time:'',
          gas_name:'',
          export_type:'ty',
          type_id:'',
        },
        settleData:{
          order_id:'',
          amount:'',
          total_amount:'',
          settle_amount:'',
          mobile:'',
        },
        tableColumn: [
          {title:'ID',key:'order_id',align:'center'},
          {title: '用户',key: 'mobile',align: "center"},
          {title:'油站',key:'gas_name',align:'center'},
          {title:'枪号',key:'gun_no',align:'center'},
          {title:'照片',align:'center',render:(h,params)=>{
            let images = [],imagesContent=[];
           params.row.images.forEach((val)=>{
             images.push(val)
             imagesContent.push(h('img',{attrs:{src:val},style:{width:"30px",height:'30px',marginLeft:'5px'}}))
           })
            if (images.length<=0) return h('p','');
              return h('viewer',{
                props:{images:images},
              },imagesContent)
            }},
          {title:'数量',key:'litre_num',align:'center'},
          // {title:'单价',key:'gas_price',align:'center'},
          // {title:'总额',key:'total_price',align:'center'},
          // {title:'已结算',key:'settled_amount',align:'center'},
          // {title:'下单时间',key:'create_time',align:'center',width:170},
          {title:'支付时间',key:'pay_time',align:'center',width:170},
        ],
        tableData: [],
        countData:{},
        stations:[],
      }
    },
    methods: {
      showDetail(order_id){
        this.editOrderId = order_id
        this.showOrderDetail = true
      },
      showUserDetailPage(user_id){
        this.editUserId = user_id
      },
      doneFunction(res){
        this.countData = res.extra
      },
    },
    mounted() {
      this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:'oil_station'}).then((res)=>{
        this.stations = res.data.oil_station
      })
    },
  }
</script>

<style scoped>
  .drawer-footer{
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
